
  document.addEventListener('DOMContentLoaded', function () {  
    formInit('.communication__forms')

    function formInit(form) {
      var block = document.querySelector(form);
      if (!block) return;

      var form = block.querySelector(".form");
      var formWrapper = block.querySelector('.forms__wrapper');
      var formSuccess = block.querySelector('.forms__success');
      
      async function handleSubmit(event) {
        event.preventDefault();
        var status = document.getElementById("my-form-status");
        var data = new FormData(event.target);
        fetch(event.target.action, {
          method: form.method,
          body: data,
          headers: {
              'Accept': 'application/json'
          }
        }).then(response => {
          if (response.ok) {
            formSuccess.classList.add('forms__success_active');
            formWrapper.classList.add('forms__wrapper_hidden');
            form.reset()
          } else {
            response.json().then(data => {
              if (Object.hasOwn(data, 'errors')) {
                status.innerHTML = data["errors"].map(error => error["message"]).join(", ")
              } else {
                status.innerHTML = "Oops! There was a problem submitting your form"
              }
            })
          }
        }).catch(error => {
          status.innerHTML = "Oops! There was a problem submitting your form"
        });
      }
      form.addEventListener("submit", handleSubmit);

      const closePopup = form.querySelector('.hc-drawer-top .cros')

      closePopup.addEventListener('click', () => {    
        if (formSuccess.classList.contains('forms__success_active')) {
          formSuccess.classList.remove('forms__success_active');
        }
        if (formWrapper.classList.contains('forms__wrapper_hidden')) {
          formWrapper.classList.add('forms__wrapper_hidden');
        }        
      })
    }
  });